import React, { Component } from 'react';

import { Input, InputBlockIcon } from 'components/input';
import PropTypes from 'prop-types';

class InputGroupIcon extends Component {
  static propTypes = {
    maxLength: PropTypes.number,
    name: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string
  };

  render() {
    const { placeholder, type, onChange, value, name, maxLength, ...props } =
      this.props;

    return (
      <InputBlockIcon {...props}>
        <Input
          id={name}
          maxLength={maxLength}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          type={type}
          value={value}
        />
      </InputBlockIcon>
    );
  }
}

export default InputGroupIcon;
